import React from "react";

export const LOCALE_STORAGE_KEY = "harbor-lens-locale";
export const LOCALES = ["zh", "en"];

const messages = {
  zh: {
    "language.zh": "中文",
    "language.en": "English",
    "language.label": "语言",
    "brand.tagline": "样例观测台",
    "intro.kicker": "LOCAL-FIRST SAMPLE OBSERVATORY",
    "intro.titleA": "看清一道题，",
    "intro.titleB": "不只看那个 0 分。",
    "intro.body": "把 Harbor Coding 样例的题面、Gate、Rubrics、Requirements 与 GPT / Opus rollout 轨迹放进同一张检查桌。",
    "intro.openDirectory": "导入样例目录",
    "intro.openBundle": "打开 .harborlens.json bundle",
    "intro.loadProject": "读取本项目 012 / 036 / 037 / 038 / 041",
    "intro.loadPublished": "加载已发布 ZIP",
    "intro.loadingPublished": "加载已发布内容…",
    "intro.loading": "读取中…",
    "intro.foot.browser": "浏览器内解析",
    "intro.foot.score": "effective=max(final, graded)",
    "intro.foot.pages": "Cloudflare Pages ready",
    "drop.title": "放下样例目录或 ZIP",
    "drop.body": "所有解析都留在本机浏览器",
    "error.noSamples": "没有识别到 task.toml 或 rollout summary.json",
    "error.staticDisk": "当前是静态部署，无法直接读取服务器磁盘；请拖入目录/ZIP。开发模式可自动读取本项目。",
    "error.bundleShape": "本地数据接口格式错误",
    "error.publishedEmpty": "当前没有已发布 ZIP",
    "empty.noSample": "没有样例",
    "empty.noSampleBody": "导入包含 task.toml 的题目目录，以及可选的 rollout runs。",
    "tab.overview": "总览",
    "tab.instruction": "Instruction",
    "tab.rubrics": "Gate & Rubrics",
    "tab.trajectory": "Trajectory",
    "tab.requirements": "Requirements",
    "tab.files": "文件",
    "status.requirementsClear": "requirements clear",
    "status.blockers": "{{count}} 个硬错误",
    "sidebar.directory": "目录",
    "sidebar.bundle": "ZIP / bundle",
    "sidebar.loadProject": "读取当前项目",
    "sidebar.loadPublished": "加载已发布 ZIP",
    "sidebar.loadingPublished": "加载中…",
    "sidebar.publishedPublic": "已发布 ZIP 对所有知道链接的人公开",
    "sidebar.privacy": "文件只在浏览器内解析；部署到 Cloudflare 后也不会上传。",
    "sidebar.samples": "样例",
    "sidebar.trajectories": "轨迹",
    "sidebar.staticPass": "静态通过",
    "sidebar.errors": "错误",
    "sidebar.search": "搜索样例或场景",
    "sidebar.localSamples": "LOCAL SAMPLES",
    "sidebar.waiting": "等待导入样例",
    "sidebar.profile": "Requirements · 20260808 profile",
    "copy.copy": "复制",
    "copy.copied": "已复制",
    "common.pass": "通过",
    "common.fail": "未通过",
    "common.missing": "缺失",
    "common.measured": "已测量",
    "common.verifierError": "verifier error",
    "common.agent": "agent {{status}}",
    "common.statusCompleted": "已完成",
    "common.statusFailed": "失败",
    "common.statusUnknown": "未知状态",
    "common.gate": "gate {{value}}",
    "common.gatesFailed": "{{count}} gates failed",
    "common.gateClipped": "gate-clipped",
    "common.hashChanged": "hash changed",
    "common.final": "FINAL",
    "common.graded": "GRADED",
    "common.effective": "EFFECTIVE",
    "common.oracle": "ORACLE",
    "common.nop": "NOP",
    "common.duration": "duration",
    "common.toolSteps": "tool steps",
    "common.llmCalls": "LLM calls",
    "common.steps": "{{count}} steps",
    "common.items": "{{count}} items",
    "common.binary": "二进制文件 · {{size}}",
    "overview.acceptance": "验收态势",
    "overview.acceptanceEyebrow": "ACCEPTANCE SNAPSHOT",
    "overview.staticPass": "静态合同通过",
    "overview.hardErrors": "{{count}} 个硬错误",
    "overview.waitingCapabilities": "等待元数据中的能力说明。",
    "overview.rubrics": "RUBRICS",
    "overview.rubricsMeta": "{{gates}} 个 Gate · {{programmatic}} 个程序化检查",
    "overview.programmaticShare": "PROGRAMMATIC SHARE",
    "overview.programmaticTarget": "目标 ≤ 20%",
    "overview.anchorWeight": "ANCHOR WEIGHT",
    "overview.anchorTarget": "目标 ≥ 30%",
    "overview.rolloutsEyebrow": "FRESH MODEL ROLLOUTS",
    "overview.rollouts": "双模型难度校准",
    "overview.scoreHint": "有效分 = max(final, graded) · 目标 0.30–0.50",
    "overview.noRollouts": "尚未导入 rollout summary。",
    "overview.tooEasy": "{{scores}}，题目过易。",
    "overview.controlsEyebrow": "CONTROL RUNS",
    "overview.controls": "Oracle / 空产物预检",
    "overview.auditEyebrow": "REQUIREMENTS AUDIT",
    "overview.keyIssues": "最重要的问题",
    "overview.viewAll": "查看全部 →",
    "overview.noViolations": "当前载入信息下未发现 Requirements 违规。",
    "overview.controlMissing": "missing",
    "overview.controlMeasured": "measured",
    "instruction.prompt": "PROMPT",
    "instruction.copy": "复制 instruction",
    "instruction.missing": "未载入 instruction.md",
    "instruction.pathEyebrow": "PATH CONTRACT",
    "instruction.pathTitle": "交付路径合同",
    "instruction.note": "题面应告诉 Agent 哪里读、哪里改、唯一输出到哪里，但不泄露 hidden tests、rubric 或 golden。",
    "rubric.eyebrow": "SCORING CONTRACT",
    "rubric.title": "Gate 与 Rubrics",
    "rubric.all": "全部",
    "rubric.judge": "Judge",
    "rubric.gate": "Gate",
    "rubric.programmatic": "程序化",
    "rubric.kindJudge": "Judge",
    "rubric.kindGate": "Gate",
    "rubric.kindProgrammatic": "程序化",
    "rubric.llmJudge": "LLM Judge",
    "rubric.hardGates": "Hard Gates",
    "rubric.programmaticCount": "Programmatic",
    "rubric.weight10": "Weight 10",
    "rubric.programmaticWeight": "Programmatic weight",
    "rubric.veto": "veto",
    "rubric.positive": "positive",
    "rubric.negative": "负向",
    "rubric.decoratorDescription": "程序化检查（描述在 Python criterion decorator 中）",
    "rubric.coverageEyebrow": "INSTRUCTION ↔ RUBRIC",
    "rubric.coverageTitle": "题面锚定启发式",
    "rubric.noAnchor": "未找到直接词面锚点",
    "rubric.coverageNote": "这是快速审阅提示，不替代人工判断；Implicit rubric 合理时可能没有逐字锚点。",
    "rubric.translationPending": "中文译文按 task_id + criterion_id + source_hash 绑定；当前显示正式英文原文。",
    "rubric.translationBound": "已绑定 {{count}} 条 source-hash 译文",
    "rubric.translationStale": "未找到匹配 source-hash；显示正式英文原文",
    "requirements.eyebrow": "20260808 EXTERNAL PROFILE",
    "requirements.title": "Requirements 对照",
    "requirements.export": "导出报告",
    "requirements.pass": "PASS",
    "requirements.needsWork": "NEEDS WORK",
    "requirements.summary": "{{errors}} errors · {{warnings}} warnings",
    "requirements.judgeGate": "Judge + Gate",
    "requirements.critical": "critical",
    "requirements.anchors": "anchors",
    "requirements.codeWeight": "code weight",
    "requirements.all": "全部",
    "requirements.error": "错误",
    "requirements.warning": "警告",
    "requirements.severityError": "错误",
    "requirements.severityWarning": "警告",
    "requirements.noIssues": "此筛选下没有问题。",
    "trajectory.missing": "尚未导入 GPT/Opus trajectory.json。",
    "trajectory.eyebrow": "ATIF TRAJECTORY",
    "trajectory.title": "Rollout 轨迹",
    "trajectory.vetoEyebrow": "VETO AUDIT",
    "trajectory.vetoTitle": "Gate 判定",
    "trajectory.search": "搜索命令、消息或 observation",
    "trajectory.judgeEyebrow": "JUDGE DETAIL",
    "trajectory.judgeTitle": "逐条评分明细",
    "trajectory.onlyMissed": "只看未通过",
    "trajectory.observation": "observation",
    "trajectory.pass": "PASS",
    "trajectory.miss": "MISS",
    "trajectory.event": "event",
    "trajectory.tool": "tool",
    "trajectory.unknown": "unknown",
    "trajectory.sourceUser": "用户",
    "trajectory.sourceAgent": "Agent",
    "trajectory.veto": "否决",
    "file.local": "LOCAL FILE",
    "file.select": "请选择文件",
    "file.filter": "筛选文件",
    "file.binary": "二进制文件 · {{size}}",
    "file.copy": "复制",
    "bilingual.summary": "场景摘要",
    "bilingual.originalNotice": "样例原文保持英文；这里只翻译网站界面和审阅摘要。",
  },
  en: {
    "language.zh": "中文",
    "language.en": "English",
    "language.label": "Language",
    "brand.tagline": "sample observatory",
    "intro.kicker": "LOCAL-FIRST SAMPLE OBSERVATORY",
    "intro.titleA": "See the task,",
    "intro.titleB": "not just the zero.",
    "intro.body": "Bring the Harbor Coding prompt, gates, rubrics, requirements, and GPT / Opus rollout traces onto one inspection desk.",
    "intro.openDirectory": "Import sample directory",
    "intro.openBundle": "Open .harborlens.json bundle",
    "intro.loadProject": "Load project samples 012 / 036 / 037 / 038 / 041",
    "intro.loadPublished": "Load published ZIP",
    "intro.loadingPublished": "Loading published content…",
    "intro.loading": "Loading…",
    "intro.foot.browser": "Parsed in browser",
    "intro.foot.score": "effective=max(final, graded)",
    "intro.foot.pages": "Cloudflare Pages ready",
    "drop.title": "Drop a sample directory or ZIP",
    "drop.body": "All parsing stays in this browser",
    "error.noSamples": "No task.toml or rollout summary.json was found",
    "error.staticDisk": "This is a static deployment and cannot read the server disk; drop a directory/ZIP instead. Dev mode can load the project.",
    "error.bundleShape": "Invalid local data bundle",
    "error.publishedEmpty": "No published ZIP is available",
    "empty.noSample": "No sample",
    "empty.noSampleBody": "Import a task directory containing task.toml, with optional rollout runs.",
    "tab.overview": "Overview",
    "tab.instruction": "Instruction",
    "tab.rubrics": "Gate & Rubrics",
    "tab.trajectory": "Trajectory",
    "tab.requirements": "Requirements",
    "tab.files": "Files",
    "status.requirementsClear": "requirements clear",
    "status.blockers": "{{count}} blockers",
    "sidebar.directory": "Directory",
    "sidebar.bundle": "ZIP / bundle",
    "sidebar.loadProject": "Load project",
    "sidebar.loadPublished": "Load published ZIP",
    "sidebar.loadingPublished": "Loading…",
    "sidebar.publishedPublic": "Published ZIPs are public to anyone with the link",
    "sidebar.privacy": "Files are parsed in the browser; deployment to Cloudflare does not upload them.",
    "sidebar.samples": "samples",
    "sidebar.trajectories": "trajectories",
    "sidebar.staticPass": "static pass",
    "sidebar.errors": "errors",
    "sidebar.search": "Search samples or scenes",
    "sidebar.localSamples": "LOCAL SAMPLES",
    "sidebar.waiting": "Waiting for samples",
    "sidebar.profile": "Requirements · 20260808 profile",
    "copy.copy": "Copy",
    "copy.copied": "Copied",
    "common.pass": "pass",
    "common.fail": "fail",
    "common.missing": "missing",
    "common.measured": "measured",
    "common.verifierError": "verifier error",
    "common.agent": "agent {{status}}",
    "common.statusCompleted": "completed",
    "common.statusFailed": "failed",
    "common.statusUnknown": "unknown status",
    "common.gate": "gate {{value}}",
    "common.gatesFailed": "{{count}} gates failed",
    "common.gateClipped": "gate-clipped",
    "common.hashChanged": "hash changed",
    "common.final": "FINAL",
    "common.graded": "GRADED",
    "common.effective": "EFFECTIVE",
    "common.oracle": "ORACLE",
    "common.nop": "NOP",
    "common.duration": "duration",
    "common.toolSteps": "tool steps",
    "common.llmCalls": "LLM calls",
    "common.steps": "{{count}} steps",
    "common.items": "{{count}} items",
    "common.binary": "Binary file · {{size}}",
    "overview.acceptance": "Acceptance snapshot",
    "overview.acceptanceEyebrow": "ACCEPTANCE SNAPSHOT",
    "overview.staticPass": "static contract pass",
    "overview.hardErrors": "{{count}} blockers",
    "overview.waitingCapabilities": "Waiting for capability metadata.",
    "overview.rubrics": "RUBRICS",
    "overview.rubricsMeta": "{{gates}} gates · {{programmatic}} programmatic checks",
    "overview.programmaticShare": "PROGRAMMATIC SHARE",
    "overview.programmaticTarget": "target ≤ 20%",
    "overview.anchorWeight": "ANCHOR WEIGHT",
    "overview.anchorTarget": "target ≥ 30%",
    "overview.rolloutsEyebrow": "FRESH MODEL ROLLOUTS",
    "overview.rollouts": "Two-model difficulty calibration",
    "overview.scoreHint": "effective = max(final, graded) · target 0.30–0.50",
    "overview.noRollouts": "No rollout summary imported yet.",
    "overview.tooEasy": "{{scores}}; the task is too easy.",
    "overview.controlsEyebrow": "CONTROL RUNS",
    "overview.controls": "Oracle / empty-output preflight",
    "overview.auditEyebrow": "REQUIREMENTS AUDIT",
    "overview.keyIssues": "Key issues",
    "overview.viewAll": "View all →",
    "overview.noViolations": "No Requirements violations found in the loaded evidence.",
    "overview.controlMissing": "missing",
    "overview.controlMeasured": "measured",
    "instruction.prompt": "PROMPT",
    "instruction.copy": "Copy instruction",
    "instruction.missing": "instruction.md was not loaded",
    "instruction.pathEyebrow": "PATH CONTRACT",
    "instruction.pathTitle": "Delivery path contract",
    "instruction.note": "The prompt should tell the agent where to read, edit, and write the sole output without leaking hidden tests, rubrics, or golden files.",
    "rubric.eyebrow": "SCORING CONTRACT",
    "rubric.title": "Gates & rubrics",
    "rubric.all": "All",
    "rubric.judge": "Judge",
    "rubric.gate": "Gate",
    "rubric.programmatic": "Programmatic",
    "rubric.kindJudge": "Judge",
    "rubric.kindGate": "Gate",
    "rubric.kindProgrammatic": "Programmatic",
    "rubric.llmJudge": "LLM Judge",
    "rubric.hardGates": "Hard Gates",
    "rubric.programmaticCount": "Programmatic",
    "rubric.weight10": "Weight 10",
    "rubric.programmaticWeight": "Programmatic weight",
    "rubric.veto": "veto",
    "rubric.positive": "positive",
    "rubric.negative": "negative",
    "rubric.decoratorDescription": "Programmatic check (description lives in the Python criterion decorator)",
    "rubric.coverageEyebrow": "INSTRUCTION ↔ RUBRIC",
    "rubric.coverageTitle": "Prompt anchoring heuristic",
    "rubric.noAnchor": "No direct wording anchor found",
    "rubric.coverageNote": "A fast review signal, not a human substitute; a sound implicit rubric may have no verbatim anchor.",
    "rubric.translationPending": "Chinese translations are keyed by task_id + criterion_id + source_hash; the canonical English description is shown until a translation is available.",
    "rubric.translationBound": "{{count}} source-hash translations bound",
    "rubric.translationStale": "No matching source hash; canonical English is shown",
    "requirements.eyebrow": "20260808 EXTERNAL PROFILE",
    "requirements.title": "Requirements audit",
    "requirements.export": "Export report",
    "requirements.pass": "PASS",
    "requirements.needsWork": "NEEDS WORK",
    "requirements.summary": "{{errors}} errors · {{warnings}} warnings",
    "requirements.judgeGate": "Judge + Gate",
    "requirements.critical": "critical",
    "requirements.anchors": "anchors",
    "requirements.codeWeight": "code weight",
    "requirements.all": "All",
    "requirements.error": "Error",
    "requirements.warning": "Warning",
    "requirements.severityError": "Error",
    "requirements.severityWarning": "Warning",
    "requirements.noIssues": "No issues in this filter.",
    "trajectory.missing": "No GPT/Opus trajectory.json was imported.",
    "trajectory.eyebrow": "ATIF TRAJECTORY",
    "trajectory.title": "Rollout trajectory",
    "trajectory.vetoEyebrow": "VETO AUDIT",
    "trajectory.vetoTitle": "Gate decisions",
    "trajectory.search": "Search commands, messages, or observations",
    "trajectory.judgeEyebrow": "JUDGE DETAIL",
    "trajectory.judgeTitle": "Criterion-level scores",
    "trajectory.onlyMissed": "Only misses",
    "trajectory.observation": "observation",
    "trajectory.pass": "PASS",
    "trajectory.miss": "MISS",
    "trajectory.event": "event",
    "trajectory.tool": "tool",
    "trajectory.unknown": "unknown",
    "trajectory.sourceUser": "user",
    "trajectory.sourceAgent": "agent",
    "trajectory.veto": "VETO",
    "file.local": "LOCAL FILE",
    "file.select": "Select a file",
    "file.filter": "Filter files",
    "file.binary": "Binary file · {{size}}",
    "file.copy": "Copy",
    "bilingual.summary": "Scenario summary",
    "bilingual.originalNotice": "Sample evidence remains in its canonical English; only the site chrome and review summaries are translated.",
  },
};

const interpolate = (value, vars) => String(value).replace(/\{\{(\w+)\}\}/g, (_, key) =>
  vars[key] === undefined ? `{{${key}}}` : String(vars[key]),
);

export const normalizeLocale = (value) => LOCALES.includes(value) ? value : "zh";

const browserStorage = () => typeof window === "undefined" ? null : window.localStorage;

export const getInitialLocale = (storage = browserStorage()) =>
  normalizeLocale(storage?.getItem?.(LOCALE_STORAGE_KEY));

export const persistLocale = (next, storage = browserStorage()) => {
  const value = normalizeLocale(next);
  storage?.setItem?.(LOCALE_STORAGE_KEY, value);
  return value;
};

export const translate = (locale, key, vars = {}) => {
  const value = messages[locale]?.[key] ?? messages.zh[key] ?? key;
  return interpolate(value, vars);
};

export const LocaleContext = React.createContext({
  locale: "zh",
  setLocale: () => {},
  t: (key, vars) => translate("zh", key, vars),
});

export const LocaleProvider = ({ children }) => {
  const [locale, setLocaleState] = React.useState(getInitialLocale);
  const setLocale = React.useCallback((next) => {
    const value = persistLocale(next);
    setLocaleState(value);
  }, []);
  React.useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = locale === "en" ? "en" : "zh-CN";
  }, [locale]);
  const t = React.useCallback((key, vars) => translate(locale, key, vars), [locale]);
  return React.createElement(LocaleContext.Provider, { value: { locale, setLocale, t } }, children);
};

export const useLocale = () => React.useContext(LocaleContext);

// The sidecar intentionally only contains human-reviewed summaries and shared gates.
// Canonical instruction, code, trajectory, and rubric descriptions are never translated.
export const bilingualTaskSummaries = {
  "COD-OTHER-001": {
    zh: "修复 Dulwich pack ingestion 的生产完整性事故，覆盖恶意 delta、SHA-1/SHA-256 身份域、隔离发布、migration epoch、并发与崩溃恢复。",
    en: "Repair the Dulwich pack-ingestion integrity incident across malicious deltas, SHA-1/SHA-256 identity domains, isolated publication, migration epochs, concurrency, and crash recovery.",
  },
  "COD-OTHER-002": {
    zh: "修复工业 MQTT 5 入口在 TCP 分片、重连、持久化超时与配额核算组合故障下的 parser/session 状态。",
    en: "Repair the industrial MQTT 5 ingress parser/session state across TCP fragmentation, reconnects, persistence timeouts, and quota accounting.",
  },
  "COD-OTHER-003": {
    zh: "修复边缘数据库 SQLite WAL 恢复分歧，重建 checksum、commit boundary、page image、capture epoch 与 handoff 的确定性契约。",
    en: "Repair SQLite WAL recovery divergence in an edge database and restore deterministic checksum, commit-boundary, page-image, capture-epoch, and handoff contracts.",
  },
  "COD-OTHER-004": {
    zh: "修复 PACS 医学影像中 DICOM encapsulated-frame 边界元数据的矛盾、随机/顺序访问不一致及 buffer 所有权问题。",
    en: "Repair contradictory DICOM encapsulated-frame boundary metadata, random/sequential access divergence, and buffer ownership in a PACS imaging reader.",
  },
  "COD-OTHER-005": {
    zh: "修复 Git pack delta-chain 重建，覆盖 OFS_DELTA/REF_DELTA、深层依赖、前向引用、资源上限、manifest 原子发布和 canonical ID 证明。",
    en: "Repair Git pack delta-chain reconstruction across OFS_DELTA/REF_DELTA, deep dependencies, forward references, resource limits, atomic manifest publication, and canonical-ID proofs.",
  },
  "COD-OTHER-006": {
    zh: "修复广播自动化 timecode 事故，覆盖 29.97/59.94 drop-frame、跨日标签、精确时长、batch 切分和 checkpoint resume。",
    en: "Repair a broadcast-automation timecode incident covering 29.97/59.94 drop-frame behavior, cross-midnight labels, exact durations, batch splitting, and checkpoint resume.",
  },
  "COD-OTHER-007": {
    zh: "修复工业 WebSocket gateway 的 fragmentation、control-frame 交错、permessage-deflate、UTF-8、decoded-size、session generation 与 backpressure 状态。",
    en: "Repair an industrial WebSocket gateway across fragmentation, interleaved control frames, permessage-deflate, UTF-8, decoded size, session generations, and backpressure.",
  },
  "COD-OTHER-008": {
    zh: "修复医疗/工业 TAR/PAX reader 的 UTF-8 长度不动点、global/local metadata 优先级、retry identity、取消和并发事务边界。",
    en: "Repair a medical/industrial TAR/PAX reader across UTF-8 length fixed points, global/local metadata precedence, retry identity, cancellation, and concurrent transaction boundaries.",
  },
  "COD-OTHER-009": {
    zh: "修复医疗/工业 ZIP reader 的 ZIP64 sentinel 布局、extra-field TLV、Unicode filename CRC 绑定及 local/central header identity 矛盾。",
    en: "Repair a medical/industrial ZIP reader across ZIP64 sentinel layout, extra-field TLVs, Unicode filename CRC binding, and local/central header identity conflicts.",
  },
};

export const getTaskSummary = (taskId, locale, fallback = "") =>
  bilingualTaskSummaries[taskId]?.[locale] || fallback;

export const localizeIssue = (item, locale, t) => {
  if (locale === "zh") return item.message;
  const templates = {
    parse_error: "Parse error: {{message}}",
    required_file_missing: "Required file is missing: {{path}}",
    residual_file: "Forbidden residual found: {{name}}",
    instruction_path_contract: "instruction.md does not {{label}}",
    schema_version: 'schema_version must be "1.4"',
    task_id_mismatch: "Directory/task_id mismatch: {{message}}",
    task_name_mismatch: "[task].name does not match {{id}}",
    task_org: "[task].name must use the AlvanceAI/ prefix",
    keywords: 'keywords must be ["coding", "office", difficulty]',
    office_task_type: "Coding office_task_type must be 其他 (Other)",
    vl_dependency: "Non-visual coding tasks must declare 不依赖vl (no VL dependency)",
    artifacts_mismatch: "artifacts do not match required deliverables",
    deliverable_path: "Required deliverable must be an exact filename",
    golden_missing: "Golden output is missing: {{message}}",
    instruction_deliverable: "instruction.md does not name {{message}}",
    judge_files: "Judge file list is missing {{message}}",
    golden_mismatch: "The two golden submission.patch files differ",
    agent_timeout: "agent.timeout_sec must be at least 72000",
    verifier_timeout: "verifier.timeout_sec must be at least 18000",
    verifier_network: "verifier must use allowlist with ${JUDGE_GATEWAY}",
    verifier_env: "verifier environment variable must use its placeholder",
    environment_network: "Coding snapshots should normally use no-network",
    docker_contract: "Dockerfile is missing a required contract marker",
    pytest_missing: "The agent image does not install pytest",
    coding_verify_task_toml: "coding_verify.py must not read task.toml",
    coding_verify_path: "coding_verify.py is missing a required fixed path",
    rubric_index_mismatch: "rubric_index does not exactly match Judge/Gate IDs",
    weight_value: "{{message}} (allowed weights: 3, 7, 10)",
    criterion_type: "Criterion type must be binary",
    rubric_weight_mismatch: "Criterion weight differs from rubric_index",
    gate_weight: "Gate criteria must not declare a weight",
    gate_shape: "Gate criteria must be binary with negate=true",
    judge_model: "Graded Judge must be openai/gpt-5.5",
    gate_judge_model: "Gating Judge must be openai/gpt-5.5",
    judge_aggregation: "Graded aggregation must be weighted_mean",
    gate_aggregation: "Gating aggregation must be all_pass",
    programmatic_share: "Programmatic positive weight exceeds 20%",
    rubric_count: "The task does not meet the minimum rubric count",
    critical_count: "At least two positive weight=10 rubrics are required",
    negative_ratio: "Negative graded rubrics are below 20%",
    anchor_ratio: "Domain-anchor positive weight is below 30%",
    secret_detected: "Possible credential material detected",
    rollout_agent_failed: "{{message}}",
    rollout_verifier_error: "{{message}}",
    rollout_gate_unavailable: "{{message}}",
    rollout_hash_stale: "{{message}}",
    model_score_high: "{{message}}",
    model_score_low: "{{message}}",
    rollout_missing: "{{message}}",
    rubric_duplicate: "Duplicate rubric descriptions detected",
  };
  const template = templates[item.code];
  if (!template) return item.message;
  const translated = template
    .replace("{{message}}", item.message)
    .replace("{{path}}", item.path || "")
    .replace("{{name}}", item.path || "")
    .replace("{{label}}", item.message.replace(/^instruction\.md 未/, ""))
    .replace("{{id}}", item.message.match(/与\s*([^ ]+)/)?.[1] || "the sample");
  return translated;
};
